import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import { getInitPopUpData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
//import SnGrid from "@shared/components/Grid/SnGrid";
import SnGrid from "@shared/components/GridV2/SnGrid";
import SnSearchBtn from "@shared/components/SnSearchBtn";
import SnTabHeader from "@shared/components/SnTabHeader";
import { SnButton } from "@shared/components/SnButton";
import { showDialog } from "@widgets/CommonDialog";

interface popupProps {
  selectedDataList?: any;
  selectedData: any;
  modalRef?: any;
}

interface RowData {
  KeyField?: string; // 행의 고유 ID
  [key: string]: any;
}

const SN_QMS_REQ_REG_001_POP_01 = forwardRef(
  (
    { selectedData, selectedDataList, modalRef }: popupProps,
    ref: React.Ref<any>
  ) => {
    //#region variable
    const { userInfo } = global();
    const searchRef = useRef<any>(null);
    //#endregion

    //#region Components useState
    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
      grid1: React.createRef(),
      grid2: React.createRef(),
    });
    const [columns, setColums] = useState<any>({
      grid1: [],
      grid2: [],
    });
    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
      grid2: [],
    });
    const [doubleData, setDoubleData] = useState<any[]>();
    const [popupParent, setPopupParent] = useState<any>(null);
    //#endregion

    useImperativeHandle(ref, () => ({
      getSelectedRow: () => [
        gridRefs.current["grid1"].current.getSelectedRows() || [],
        gridRefs.current["grid2"].current.getSelectedRows() || [],
      ],
    }));

    useEffect(() => {
      if (doubleData) {
        modalRef.current?.handleConfirm(true);
      }
    }, [doubleData]);

    useEffect(() => {
      if (modalRef?.current) {
        setPopupParent(modalRef.current.getPopupParent());
      }
    }, [modalRef?.current]);

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_QMS_REQ_REG_001_POP_01",
            {}
          );
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormControlData(rtn.formControlData); // 조회조건 항목 설정
          setFormData(mergedData); // 조회조건 초기값
          setColums({
            grid1: rtn.grid.grid1,
            grid2: rtn.grid.grid2,
          });
        } catch (error) {}
      };
      fetchform();
    }, [userInfo]);

    //#region Button Event
    const onSearch = async () => {
      const fetchdatasource = async () => {
        try {
          const params = {
            id: "sn_qms_req_reg_001_pop_01",
            params: searchRef.current.getFormdata(),
          };

          const data: any = await fnGetDataSet(params);
          setDataSources({
            grid1: data[0],
            grid2: data[1],
          });

          gridRefs.current["grid1"].current.selectAndFocusRow(0);
          gridRefs.current["grid1"].current.resetUpdate();
        } catch (error) {
          console.log(error);
        }
      };
      await fetchdatasource();
    };

    const onFocusedRowChanged = (event: any) => {
      const selectedRow = event; // 클릭한 행 데이터
      if (selectedRow) {
        // 배열로 만들어서 필터링 함수 호출
        const cd_item = selectedRow.cd_item;
        gridRefs.current["grid2"].current.applyFilters({ cd_item: cd_item });
        gridRefs.current["grid2"].current.selectAndFocusRow(0);
      } else {
        return;
      }
    };

    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
          events: {
            onFocusedRowChanged,
          },
        },
        grid2: {
          columns: columns.grid2,
          dataSource: dataSources.grid2,
        },
      }),
      [columns, dataSources]
    );

    return (
      <div className="h-full flex flex-col">
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          />
        </div>

        <div style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{ width: 80, marginTop: 1.5 }}
            spinner={true}
          />
        </div>

        {/* 그리드 영역을 가로로 배치 */}
        <div
          style={{
            display: "flex",
            gap: "10px",
            marginTop: "10px",
            height: "60vh",
          }}
        >
          {/* 왼쪽 그리드 */}
          <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
            <SnGrid
              ref={gridRefs.current["grid1"]}
              columnConfig={grids.grid1.columns}
              rowData={grids.grid1.dataSource}
              etcProps={{
                isEditable: true,
                rowSelection: "single",
                popupParent: popupParent,
              }}
              events={grids.grid1.events}
            />
          </div>

          {/* 오른쪽 그리드 */}
          <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
            <SnGrid
              ref={gridRefs.current["grid2"]}
              columnConfig={grids.grid2.columns}
              rowData={grids.grid2.dataSource}
              etcProps={{
                isEditable: true,
                rowSelection: "multiple",
              }}
            />
          </div>
        </div>
      </div>
    );
  }
);

export default SN_QMS_REQ_REG_001_POP_01;
